import { RegisterModule } from '@/typings/common'
import {
  LkPublicationsState,
  LkPublicationsGetters,
  LkPublicationsMutations,
  LkPublicationsActions,
} from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: LkPublicationsState,
    getters: LkPublicationsGetters,
    mutations: LkPublicationsMutations,
    actions: LkPublicationsActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as lkPublicationsStoreModule,
  mapper as lkPublicationsMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
